import { useLocation, useNavigate } from "react-router-dom";

import {
  FORM_ORIGINS,
  revenueOpportunityPaths,
} from "routes/revenue_opportunity/paths";

/**
 * The record page an embedded table sits on, read from the parent ids it is
 * scoped by. A campaign target table carries both its campaign and entity.
 */
export const originFromScope = ({
  entityId,
  campaignId,
  caseId,
  contactId,
}) => {
  if (caseId) return FORM_ORIGINS.case;
  if (contactId) return FORM_ORIGINS.contact;
  if (campaignId && entityId) return FORM_ORIGINS.campaignTarget;
  if (campaignId) return FORM_ORIGINS.campaign;
  if (entityId) return FORM_ORIGINS.entity;
  return null;
};

/**
 * Opens the Revenue Opportunity form pages. The current location travels as
 * `from`, so Cancel and the back link return to where the user started.
 */
export const useRevenueOpportunityNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  return {
    openCreate: preset =>
      navigate(revenueOpportunityPaths.create(preset), { state }),
    openEdit: id => navigate(revenueOpportunityPaths.edit(id), { state }),
    openClone: id => navigate(revenueOpportunityPaths.clone(id), { state }),
  };
};
